import { Box, Typography, Paper } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import DealCard from './DealCard';

const KanbanBoard = ({ pipeline, onDragEnd }) => {
	// If pipeline is empty or not provided, don't render anything
	// Empty state handling is now in the parent component
	if (!pipeline || pipeline.length === 0) {
		return null;
	}

	return (
		<DragDropContext onDragEnd={onDragEnd}>
			<Box
				sx={{
					display: 'flex',
					gap: 2,
					overflowX: 'auto',
					pb: 2,
				}}
			>
				{pipeline.map((stage) => (
					<Paper
						key={stage.stage_id}
						elevation={0}
						sx={{
							width: 300,
							minHeight: 400,
							minWidth: 280,
							flex: '0 0 auto',
							borderRadius: 1,
							p: 2,
							backgroundColor: (theme) => theme.palette.background.default,
							border: '1px solid',
							borderColor: 'divider',
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						{/* Column header - OUTSIDE Droppable area */}
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								pb: 1.5,
								mb: 1.5,
								borderBottom: '1px solid',
								borderColor: 'divider',
							}}
						>
							<Typography variant='h6' fontWeight='medium'>
								{stage.stage_name}
							</Typography>
							<Typography
								variant='body2'
								sx={{
									borderRadius: 5,
									px: 1.5,
									py: 0.5,
									bgcolor: 'action.selected',
									fontWeight: 'medium',
								}}
							>
								{stage.deals.length}
							</Typography>
						</Box>
						
						{/* Cards container - Droppable area */}
						<Droppable droppableId={stage.stage_id}>
							{(provided) => (
								<Box
									ref={provided.innerRef}
									{...provided.droppableProps}
									sx={{
										display: 'flex',
										flexDirection: 'column',
										gap: 1.5,
										flex: 1,
										minHeight: 100,
										overflowY: 'auto',
									}}
								>
									{stage.deals.length > 0 ? (
										stage.deals.map((deal, index) => (
											<Draggable
												key={deal.id}
												draggableId={deal.id}
												index={index}
											>
												{(provided) => (
													<Box
														ref={provided.innerRef}
														{...provided.draggableProps}
														{...provided.dragHandleProps}
													>
														<DealCard deal={deal} />
													</Box>
												)}
											</Draggable>
										))
									) : (
										<Box
											sx={{
												height: '100%',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												color: 'text.disabled',
												fontStyle: 'italic',
												fontSize: '0.875rem',
											}}
										>
											No deals in this stage
										</Box>
									)}
									{provided.placeholder}
								</Box>
							)}
						</Droppable>
					</Paper>
				))}
			</Box>
		</DragDropContext>
	);
};

export default KanbanBoard;
